import { Api, BASE_URL } from '@/api/index';
import axios, { AxiosRequestConfig } from 'axios';
import { PlatformRole, ProjectRole, UserStatus } from 'ignite360-core';

export type AdminUserProject = {
  id: string;
  name: string;
  role: ProjectRole;
  status: UserStatus;
};

export type AdminUserListItem = {
  id: string;
  email: string;
  role: PlatformRole;
  status: UserStatus;
  projects: AdminUserProject[];
};

export class AdminApi {
  static async loadUsers(): Promise<AdminUserListItem[]> {
    const config: AxiosRequestConfig = Api.finalizeConfig({
      method: 'GET',
      url: `${BASE_URL}/admin/users`,
    });

    const result = await axios.request<AdminUserListItem[]>(config);
    if (result.status === 200 && result.data) {
      return result.data;
    }
    throw new Error('Could not load users.');
  }
}
